module.exports = __webpack_public_path__ + "c_static/img/Praise_img_bg_default@2x.96e77c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/05_好评返现/Praise_img_bg_default@2x.png
// module id = 6YwQ
// module chunks = 33